import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/** 江西检测项目管理接口。 */
export const projectService = {
  page: params => axios.get(`${iffApi}/jxxf/jc/project`, { params }),
  detail: id => axios.get(`${iffApi}/jxxf/jc/project/${id}`),
  buildings: (id, params) => axios.get(`${iffApi}/jxxf/jc/project/${id}/buildings`, { params }),
  facilities: () => axios.get(`${iffApi}/jxxf/jc/project/facilities`),
  create: data => axios.post(`${iffApi}/jxxf/jc/project`, data),
  update: (id, data) => axios.put(`${iffApi}/jxxf/jc/project/${id}`, data),
  saveConclusion: (id, data) => axios.put(`${iffApi}/jxxf/jc/project/${id}/conclusion`, data),
  modification: (id, data) => axios.post(`${iffApi}/jxxf/jc/project/${id}/modification`, data),
  delete: id => axios.delete(`${iffApi}/jxxf/jc/project/${id}`),
  points: (id, params) => axios.get(`${iffApi}/jxxf/jc/project/${id}/points`, { params }),
  items: (id, params) => axios.get(`${iffApi}/jxxf/jc/project/${id}/items`, { params }),
  itemSummary: id => axios.get(`${iffApi}/jxxf/jc/project/${id}/item-summary`),
  pointItems: (id, pointId) => axios.get(`${iffApi}/jxxf/jc/project/${id}/points/${pointId}/items`),
  pointCategories: (id, params) => axios.get(`${iffApi}/jxxf/jc/project/${id}/point-categories`, { params })
};
